import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarDays } from "lucide-react";
import { it, enUS, es, fr, de } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { formatDate } from "../lib/format";

const LOCALES = { it, en: enUS, es, fr, de };
const DROPDOWNS = {
  caption_label: "text-sm font-medium inline-flex items-center gap-1",
  caption_dropdowns: "flex gap-3 justify-center",
  dropdown_month: "relative inline-flex items-center",
  dropdown_year: "relative inline-flex items-center",
  dropdown: "absolute inset-0 w-full opacity-0 cursor-pointer z-10",
  dropdown_icon: "h-3 w-3",
  vhidden: "sr-only",
};
const toIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const fromIso = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const DateField = ({ id, value, onChange, testId, className = "field-input" }) => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const selected = fromIso(value);
  const today = new Date();
  const pick = (d) => {
    onChange(d ? toIso(d) : "");
    setOpen(false);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button id={id} type="button" className={`${className} flex items-center justify-between gap-2 text-start`} data-testid={testId}>
          <span className={value ? "" : "text-[hsl(var(--muted-foreground))]"}>{value ? formatDate(value) : t("wizard.pick_date")}</span>
          <CalendarDays size={16} className="opacity-60 shrink-0" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testId}-popover`}>
        <Calendar mode="single" selected={selected} defaultMonth={selected || today} onSelect={pick} captionLayout="dropdown-buttons" fromYear={1950} toDate={today} disabled={{ after: today }} locale={LOCALES[i18n.language] || enUS} classNames={DROPDOWNS} initialFocus />
        {value && (
          <button type="button" onClick={() => pick(null)} className="w-full border-t py-2 text-xs font-semibold hover:bg-[hsl(var(--secondary))]" data-testid={`${testId}-clear`}>
            {t("wizard.clear_date")}
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};
